const PREFIX: string = 'TOPIC_';

export const INIT_PAGE_DATA: string = PREFIX + 'INIT_PAGE_DATA';
export const INIT_LIVE_SYMBOL: string = PREFIX + 'INIT_LIVE_SYMBOL';

/**
 * 初始化
 */
export function initPageData(pageData: any): any {
	return {
		type: INIT_PAGE_DATA,
		pageData,
	};
}
